import React from "react";
import GenerateElement from "./Element";
import "./Form.Page.css";
import "./Form.Effect.css";
import { PropsElement, PropsFormPage } from "../props";
import SetValueToAll from "./set.value";

/*
    Estructura de una página de formulario
    * Logo
    * title
    * subtitle
    * type
    * name
    * background
    * color
 */

function LogoComponent(props: PropsFormPage) : JSX.Element | null {
    if(typeof props.src === "string") {
        return (
            <div className="FM-div-logo">
                <img className="FM-logo" src= {props.src} alt="Smartbuy"/>
            </div>
        )
    }
    return null;
}

// Renderizar Titulo de la página
function TitleComponent(props: PropsFormPage) : JSX.Element | null {
    if(typeof props.title === "string") {
        return (
            <div className="FM-form-page-title">{props.title}</div>
        )
    }
    return null;
}

// Renderizar Subtitulo de la página
function SubtitleComponent(props: PropsFormPage) : JSX.Element | null {
    if(typeof props.subtitle === "string") {
        return <div className="FM-form-page-subtitle">{props.subtitle}</div>
    }
    return null;
}

interface ErrorProps {
    msg: string
}

// Renderizar Error de planilla
function ErrorComponent(props: ErrorProps) : JSX.Element {
    return (
        <div className="FM-form-error">{props.msg}</div>
    )
}

function ButtonBottom({next, back, onBack}: PropsFormPage) : JSX.Element | null {
    let main: Array<PropsElement> = [];

    if(typeof back === "string") {
        main.push({
            type: "button", 
            display: back,
            align: "left",
            onClick: onBack
        })
    }
    if(typeof next === "string") {
        main.push({
            type: "submit", 
            display: next,
            align: "right"
        })
    }

    if(main.length > 0) {
        let group = {type:"group", main};
        
        return <GenerateElement {...group} />;
    }
    return null;
}

interface PropsFormPageExtended extends PropsFormPage {
    initValues?: Array<any> | PropsFormPage
}

// Renderizar Página de formulario
export default class FormPage extends React.Component<PropsFormPageExtended> {
    stateElements: any = {}
    effect: string | undefined;
    error: string | null = null;
    
    constructor(props: PropsFormPageExtended) {
        super(props.initValues !== undefined ? SetValueToAll(props, props.initValues) : props);

        this.VerifyError = this.VerifyError.bind(this);
        this.HandlerOnChange = this.HandlerOnChange.bind(this);
        this.HandlerOnSubmit = this.HandlerOnSubmit.bind(this);
    }

    VerifyError() {
        let msgError: string | null = null;

        for(let msg in this.stateElements) {
            if(typeof this.stateElements[msg] === "string") {
                msgError = this.stateElements[msg];
                break;
            }
        }

        const ExplorerAll = (element: any): any => {
            if(element instanceof Object) {
                if(element.type === "group") return ExplorerAll(element.main);
                else {
                    if(element.required && (this.stateElements[element.name] === undefined && !this.props.value)) {
                        msgError = "Algunos campos son requeridos.";
                    }
                }
            }
            else if(element instanceof Array) {
                element.forEach((e: any) => ExplorerAll(e));
            }
        }

        ExplorerAll(this.props);

        return msgError;
    }

    HandlerOnSubmit(event:React.FormEvent<HTMLFormElement>) {
        event.preventDefault();
        this.error = this.VerifyError();

        if(this.error) {
            this.forceUpdate();
            return;
        }
        
        if(typeof this.props.effect === "string") {
            this.effect = this.props.effect as string;
            this.forceUpdate();
            setTimeout(
                () => {if(typeof this.props.onNext === "function") this.props.onNext();}, 500
            )
        }
        else {
            if(typeof this.props.onNext === "function") this.props.onNext();
        }
    }

    HandlerOnChange(value: any, key: string, error?: string) {
        this.stateElements[key] = error ? error : null;
        if(this.props.onChange) this.props.onChange(value, key, error);
    }
    
    render() {
        let {src,title, subtitle, back, next, onNext, onBack, ...template} = this.props; // se extraen los parametros no necesarios
    
        let render: JSX.Element;
        let color: string | undefined;
    
        // if(props instanceof Object) {
    
            color = template.color;
            
            // La planilla es válida
            render = (
                <>
                    <LogoComponent src={src}></LogoComponent>
                    <TitleComponent title={title} />
                    <SubtitleComponent subtitle={subtitle} />
                    <div className="FM-form-page-container">
                        <GenerateElement {...template} onChange={this.HandlerOnChange} />
                    </div>
                    {this.error && <ErrorComponent msg={this.error} />}
                    <ButtonBottom onBack={onBack} back={back} next={next} />
                </>
            )
        // }
        // else {
        //     // OOOOPS! la planilla es invalida
        //     render = <ErrorComponent msg="PLANILLA INVALIDA!" />
        // }
    
        let className = "FM-form-page";
    
        if(typeof template.effect === "string") {
            className += " FM-form-effect";
        }
        if(typeof this.effect === "string") {
            className += " FM-effect--" + this.effect;
        }
    
        // Renderizado!
        return (
            <form onSubmit={this.HandlerOnSubmit} className={className} style={{"--color": color} as any}>
                {render}
            </form>
        )
    }
}